export default __webpack_public_path__ + "static/media/Sofia Pro Bold Az.48c71aa3.otf";